// src/services/empresaService.js
import { authFetch } from "../utils/authFetch"
import { API_BASE_URL } from "../config"
const baseUrl = `${API_BASE_URL}/api/empresas`
/**
 * Obtiene el token del localStorage.
 */


/**
 * Obtiene todas las empresas (GET).
 */
export const getEmpresas = async () => {
  const response = await authFetch(baseUrl, {
    method: "GET",
  });
  if (!response.ok) {
    throw new Error("Error al consultar las empresas");
  }
  return response.json();
};

/**
 * Crea una nueva empresa (POST).
 */
export const createEmpresa = async (empresaData) => {
  
  const response = await authFetch(baseUrl, {
    method: "POST",
    body: JSON.stringify(empresaData),
  });
  if (!response.ok) {
    throw new Error("Error al crear la empresa");
  }
  return response.json();
};

/**
 * Actualiza una empresa existente (PUT).
 */
export const updateEmpresa = async (id, empresaData) => {
  const response = await authFetch(`${baseUrl}/${id}`, {
    method: "PUT",
    body: JSON.stringify(empresaData),
  });
  if (!response.ok) {
    throw new Error("Error al actualizar la empresa");
  }
  return response.json();
};